/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_PrivacyInputs */

const en_landing_footer_privacy = /** @type {(inputs: Landing_Footer_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Landing_Footer_PrivacyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const landing_footer_privacy = /** @type {((inputs?: Landing_Footer_PrivacyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_PrivacyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_privacy(inputs)
});
export { landing_footer_privacy as "landing.footer.privacy" }